module.exports = __webpack_public_path__ + "img/test_week.9c6b4370.jpg";